import { render, staticRenderFns } from "./homeDashboardGroupFitnessStatistics.vue?vue&type=template&id=d7b50f80&scoped=true"
import script from "./homeDashboardGroupFitnessStatistics.vue?vue&type=script&lang=js"
export * from "./homeDashboardGroupFitnessStatistics.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d7b50f80",
  null
  
)

export default component.exports